import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

@Injectable()
export class DeleteMarkFileService extends PlessJsonResponderSub<any> {
  // VO
  vo = {
    MarkCode: '',
    MarkCodeBranch: '',
  };

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteMarkFileService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      delete: {
        Rec: {
          condition: {
            MarkCode: this.vo.MarkCode,
            MarkCodeBranch: this.vo.MarkCodeBranch,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof DeleteMarkFileService
   */
  execute(vo: { MarkCode: any; MarkCodeBranch: any; }, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deleteMarkFile', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteMarkService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
